import { fuzzyFilter } from '@/util';
import { ColumnDef } from '@tanstack/react-table';
import { ImageDTO, ImageTypeDTO } from '@/model';
import { SelectOption } from '@/type';
import { t } from '@localization/i18n';

export const layoutEditorImageModalColumns: ColumnDef<ImageDTO>[] = [
  {
    accessorKey: 'id',
    header: 'id',
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: 'name',
    header: 'name',
    cell: (info) => info.getValue(),
    filterFn: fuzzyFilter,
    sortingFn: 'alphanumeric',
  },
  {
    accessorKey: 'file',
    header: 'file',
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: 'width',
    header: 'width',
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: 'height',
    header: 'height',
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: 'uploadDate',
    header: 'uploadDate',
    cell: (info) => info.getValue(),
  },
];

export const imageTypeSelectOptions = (elementTypes: ImageTypeDTO[]): SelectOption[] =>
  elementTypes?.map((value) => ({
    value,
    label: t(`enum.${value?.toLowerCase()}`),
  }));
